<template>
  <el-dialog custom-class="medium-dialog" title="选择人员" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="grid-content bg-purple treeContentUser">
         <CommonTreeView ref="treeDserial" :defineDataSource="true" @bindData="bindUserData" :treeHeight="180" :isShowCheckBox="true"
                         title="请选择" :canSelectGroupTypeNode="true" :onlyChildNodesCheckBox="true" @check="checktree2" @afterBindTree="setHasChecked"></CommonTreeView>
          <div hidden>
            <el-form-item label="参与人员uid" :label-width="formLabelWidth" prop="ids">
              <el-input v-model="form.ids" auto-complete="off" :required="true"></el-input>
            </el-form-item>
          </diV>
          </div>
        </el-col>
        <el-col :span="12">
          <el-button @click="clearUsers()"  size="mini" style="float: right">清 空</el-button>
          <el-table
            :data="userdata"  :height="tableHeight(140)"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <!--<el-table-column :show-overflow-tooltip="true" v-if="isLaoxian"  label="部门" align="left"  header-align="center" width="200">-->
              <!--<template slot-scope="scope">{{ scope.row['deptname'] }}</template>-->
            <!--</el-table-column>-->
            <el-table-column
              label="姓名"
              align="left"
              header-align="center"
              width="120">
              <template slot-scope="scope">
                {{scope.row['uname']}}
              </template>
            </el-table-column>
            <el-table-column
              label="删除"
              align="right"
              header-align="center"
              width="100">
              <template slot-scope="scope">
                <el-button @click="removeUsers(scope.$index,scope.row)"  size="mini">删 除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getUsersTree} from '@/api/set/post';
  import {saveData} from '@/api/oa/exchange';
  import {getEmployeeTree} from '@/api/set/employee'
  export default {
    name: "AppendUser",
    data() {
      return {
        isLaoxian: false,
        isDisable: false,
        tenantS: [],
        dialogFormVisible: false,
        receiveuguids: '',
        userdata:[],
        form: {  //表单数据
          ids: '',
          names: '',
          deptnames:'',
          isdel: 0,
          exchangeguid: '',
          extitle: '',
          feedbacktimes: 0,
        },

        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          names: [
            {required: true, message: '请选择人员', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      showAdd(userdata) {
        this.userdata = userdata;
        this.form.exchangeguid='';
        this.dialogFormVisible = true;
        this.setHasChecked();
      },
      show(extitle, exchangeguid, feedbacktimes, receiveuguids) {
        this.clearUsers();
        this.form.extitle = extitle;
        this.form.exchangeguid = exchangeguid;
        this.receiveuguids = receiveuguids;
        this.form.feedbacktimes = feedbacktimes;
        this.dialogFormVisible = true;
      },
      selectTenant() {
        this.bindUserData()
      },
      bindUserData() {
        this.$refs.treeDserial.bindData(() => {
          return getEmployeeTree({onlyShowGroupType: false, needTopNode: false})
        })
      },
      setHasChecked() {
        if (this.$refs.treeDserial) {
          var arr = [];
          for (var i = 0; i < this.userdata.length; i++) {
            arr.push(this.userdata[i].uguid);
          }
          this.$refs.treeDserial.setCheckedKeysNoemit(arr);
        }
      },
      checktree2(guids, names, arr) {
        console.log(arr)
        var newArr=[];
        for (var i = 0; i < arr.length; i++) {
          newArr.push({deptname: '', tenantid: '', uguid: arr[i].id, uname: arr[i].text});
        }
        // for(var i=0 ;i<this.userdata.length;i++) {
        //   newArr.push(this.userdata[i]);
        // }
        this.userdata=newArr;
      },
      clearUsers() {
        this.userdata = [];
        if (this.$refs.treeDserial)
          this.$refs.treeDserial.cancelCheck()
      },
      removeUsers(index,row){
        this.userdata.splice(index,1);
        this.$refs.treeDserial.setCheckedNoemit(row.uguid,false);
      },
      saveData() {
        if (this.userdata.length == 0) {
          this.$message({message: '未选人！', type: 'error'});
          return;
        }
        this.isDisable = true;
        var newids = '';
        var newnames = '';
        // var newDeptnames = '';
        for (let i in this.userdata) {
          var item = this.userdata[i];
          if (this.receiveuguids.indexOf(item.uguid) < 0) {
            newids += item.uguid + ';';
            newnames += item.uname.replace(/、/g, '') + '、';
            // newDeptnames += item.deptname.replace(/;/g, '') + ';';
          }
        }
        if (!newids) {
          this.$message({message: '人员重复！', type: 'error'});
          this.isDisable = false;
          return;
        }
        this.form.ids = newids.slice(0, newids.length - 1);
        this.form.names = newnames.slice(0, newnames.length - 1);
        // this.form.deptnames = newDeptnames.slice(0, newDeptnames.length - 1);

        if(this.form.exchangeguid) {
          //追加人员
          saveData(this.form).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '发送成功！',
                type: 'success'
              })
              //刷新列表
              this.$emit('getRightDetail', this.form.exchangeguid);
              this.dialogFormVisible = false;
            } else {
              this.$message.error(response.data.msg);
            }
            this.isDisable = false;
          });
        }else{
          //首次发邮件 选人
          this.$emit('selectUsers', this.form,this.userdata);
          this.dialogFormVisible = false;
          this.isDisable = false;
        }
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>
  .treeContentUser {
    height: calc(96vh - 200px);
    overflow: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/oa/exchange/AppendUser.vue